<template>
    <div class="col-10 box-border d-flex flex-wrap align-items-baseline bdc-sorangefive">
        <div class="col-3 d-flex flex-column justify-content-center">
            <caption class="c-nmidone">favorecido</caption>
                <el-tooltip class="item" :content="name" placement="bottom">
                    <h5 class="c-ndarkfour mb-0 break" v-if="info.bank">
                        {{ name || '-'}}
                    </h5>
                    <h5 class="c-ndarkfour mb-0 break" v-else>
                        -
                    </h5>
                </el-tooltip>
        </div>
        <div class="col-3 break-col d-flex flex-column justify-content-center">
            <caption class="c-nmidone">Banco</caption>
            <h5 class="c-ndarkfour mb-0">{{info.bank || '-'}}</h5>
        </div>
        <div class="col-1 d-flex flex-column justify-content-center">
            <caption class="c-nmidone">Agência</caption>
            <h5 class="c-ndarkfour mb-0">{{info.agency || '-'}}</h5> 
        </div>
        <div class="col d-flex flex-column justify-content-center">
            <caption class="c-nmidone">Conta</caption>
            <h5 class="c-ndarkfour mb-0">{{info.account || '-'}}</h5>
        </div>
        <div :class="info.pix ? (info.pix.length > 14) ? 'col-3 break-col p-0 d-flex flex-column justify-content-center' : 'col break-col p-0 d-flex flex-column justify-content-center' : 'col-3 break-col p-0 d-flex flex-column align-items-start'">
            <caption :class="info.pix ?  (info.pix.length > 14) ? 'c-nmidone': 'c-nmidone mr-auto pl-3 ml-1' : 'c-nmidone'">CHAVE PIX</caption>
                <el-tooltip v-if="info.pix != null && (info.pix.length > 14)" :content="info.pix" placement="bottom">
                    <h5 class="c-ndarkfour m-0 p-0 col-12 break-col">{{info.pix || '-'}}</h5>
                </el-tooltip>
                <h5 v-else :class="info.pix ? 'c-ndarkfour mr-auto pl-3 ml-1' : 'c-ndarkfour'">{{info.pix || '-'}}</h5>
        </div>
        <div v-if="info.pix" class="col-0 break-col pl-0 mt-auto mb-auto" style="padding-top: 0.8rem!important;">
            <el-tooltip content="Copiar para transferência" placement="bottom">
                <Copy :value="info.pix" />
            </el-tooltip>
        </div>
    </div>
</template>

<script>
import Copy from '../icons/Copy'
export default {
    props:{
        info:{
            required:true,
        },
        name:{
            default: null
        }
    },
    components:{
        Copy,
    },
    computed: {

    }
}
</script>

<style lang="scss" scoped>
</style>